module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/iomx-2f46be959fa407c97efd2cf53c278c16.jpg";